import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import { COLORS } from 'config'

const Button = glamorous.button(({padding}) => ({
  padding: padding,
  border: 0,
  outline: 'none',
  color: COLORS.blue,
  fontSize: 16,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'transparent',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent'
}))

Button.propTypes = {
  padding: PropTypes.number
}

Button.defaultProps = {
  padding: 0
}

export default Button



// WEBPACK FOOTER //
// ./src/components/common/Button.js